import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { RequestResponse } from '../model/dto/RequestResponse';
import { ShipmentASN } from '../model/ShipmentASN';

@Injectable()
export class ShipmentASNFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;
    private _cachedData: ShipmentASN[] = [];

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetByDates(startDate, endDate, organizationId, storeId): Observable<RequestResponse<ShipmentASN[]>> {
        return this._httpClient.get<RequestResponse<ShipmentASN[]>>(this._urlBase
            + 'api/ShipmentASN/ByDates?startDate=' + startDate + '&endDate=' + endDate + '&OrganizationId=' + organizationId + '&StoreId='+storeId)
            .pipe(tap(response => {
                if (response.completed && response.data) {
                    this._cachedData = response.data;
                }
            }));
    }

    GetByCode(code: string): Observable<RequestResponse<ShipmentASN>> {
        return this._httpClient.get<RequestResponse<ShipmentASN>>(this._urlBase + 'api/ShipmentASN/ByCode/' + code);
    }

    getCachedData(): ShipmentASN[] {
        return this._cachedData;
    }

    hasCachedData(): boolean {
        return this._cachedData.length > 0;
    }
}
